module.exports = __webpack_public_path__ + "static/media/Maginifier.24fa1b6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/Maginifier.svg
// module id = 662
// module chunks = 0